import { useTranslation as useTranslationI18Next } from 'react-i18next';

import { useSiteContext } from '@zooplus/commons-lang';
import { TFunction } from 'i18next';

export const PACKAGE_TRANSLATIONS_NAMESPACE_PREFIX =
  'landing-page/translations/own-brands-landing-page';

export const useTranslation = () => {
  const { site } = useSiteContext();
  return useTranslationI18Next(`${PACKAGE_TRANSLATIONS_NAMESPACE_PREFIX}/${site.realm}`);
};

export function getUrlLocalised(t: TFunction<'translation', undefined>, relativeUrl: string) {
  if (t('common.multilingual-locale') === 'common.multilingual-locale') return relativeUrl;
  else return t('common.multilingual-locale') + relativeUrl;
}
